export default "__VITE_ASSET__v_UusQm7__"